document.addEventListener('DOMContentLoaded', function () {
  var groups = document.querySelectorAll('[data-results-tabs]');

  groups.forEach(function (group) {
    var buttons = group.querySelectorAll('.rs-tab-btn');
    var panels = group.querySelectorAll('.rs-content-pane');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetId = button.getAttribute('data-tab-target');
        var targetPanel = group.querySelector('#' + CSS.escape(targetId));

        buttons.forEach(function (btn) {
          btn.classList.remove('active');
        });
        panels.forEach(function (panel) {
          panel.classList.remove('active');
        });

        button.classList.add('active');

        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  });

  function initBeforeAfterSlider(slider) {
    var overlay = slider.querySelector('.rs-ba-overlay');
    var divider = slider.querySelector('.rs-ba-divider');
    var beforeBadge = slider.querySelector('[data-badge-before]');
    var afterBadge = slider.querySelector('[data-badge-after]');
    var afterLabel = afterBadge ? afterBadge.textContent.trim() : 'after';
    var isDragging = false;
    var current = 50;

    if (!overlay || !divider) return;

    // A badge needs room to sit in. Below 20% of the width it is gone,
    // above 32% it is fully there, and it crossfades in between — which is
    // what replaces the old behaviour of clip-path slicing it in half.
    function badgeOpacity(sideWidthPercent) {
      return Math.max(0, Math.min(1, (sideWidthPercent - 20) / 12));
    }

    function setPosition(percent) {
      var safePercent = Math.max(0, Math.min(100, percent));
      current = safePercent;

      overlay.style.clipPath = 'inset(0 0 0 ' + safePercent + '%)';
      overlay.style.webkitClipPath = 'inset(0 0 0 ' + safePercent + '%)';
      divider.style.left = safePercent + '%';

      if (beforeBadge) {
        beforeBadge.style.opacity = badgeOpacity(safePercent);
      }
      if (afterBadge) {
        afterBadge.style.opacity = badgeOpacity(100 - safePercent);
      }

      var rounded = Math.round(safePercent);
      slider.setAttribute('aria-valuenow', rounded);
      slider.setAttribute('aria-valuetext', rounded + '% ' + afterLabel);
    }

    function updatePosition(clientX) {
      var rect = slider.getBoundingClientRect();
      if (!rect.width) return;
      var x = clientX - rect.left;
      setPosition((x / rect.width) * 100);
    }

    var startPos = parseFloat(slider.getAttribute('data-start')) || 50;
    setPosition(startPos);

    slider.addEventListener('mousedown', function (e) {
      isDragging = true;
      updatePosition(e.clientX);
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      updatePosition(e.clientX);
    });

    window.addEventListener('mouseup', function () {
      isDragging = false;
    });

    slider.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length) {
        isDragging = true;
        updatePosition(e.touches[0].clientX);
      }
    }, { passive: true });

    window.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      if (e.touches && e.touches.length) {
        updatePosition(e.touches[0].clientX);
      }
    }, { passive: true });

    window.addEventListener('touchend', function () {
      isDragging = false;
    });

    slider.addEventListener('click', function (e) {
      updatePosition(e.clientX);
    });

    // Keyboard. The wrap is role="slider" tabindex="0", so it is reachable
    // by tab; without this it would be focusable but inert.
    slider.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 5;
      var next = null;

      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        next = current - step;
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        next = current + step;
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = 100;
      }

      if (next === null) return;
      e.preventDefault(); // stop arrow keys scrolling the page
      setPosition(next);
    });
  }

  document.querySelectorAll('.rs-ba-wrap').forEach(initBeforeAfterSlider);
});